export interface IDataTableTotal {
    colId: string;
    label: string;
    text: string;
}

interface IDataTableTotalsProps {
    rowCount: number;
    selectedCount: number;
    totals: IDataTableTotal[];
}

/** Итоги полноэкранного режима: по всей таблице, а при выбранных строках — по ним. */
const DataTableTotals = ({ rowCount, selectedCount, totals }: IDataTableTotalsProps) => (
    <div className="dtb__fs-foot" data-testid="dtb-totals">
        <span className="dtb__fs-scope">{selectedCount ? `Выбрано ${selectedCount}` : 'Вся таблица'}</span>
        <span>
            Строк <b>{(selectedCount || rowCount).toLocaleString('ru-RU')}</b>
        </span>
        {totals.map((total) => (
            <span key={total.colId} className="dtb__fs-total">
                {total.label} <b>{total.text}</b>
            </span>
        ))}
    </div>
);

export default DataTableTotals;
